/*
 * Author M. Atoar Rahman
 * Title: Partner Stock Return
 * Description: Page for Partner Stock Return
 * Date: 19/06/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { StockReturnApprovalProvider } from '../centerWarehouse/partnerStockReturnReceive/ContextAPI';
import Index from '../centerWarehouse/partnerStockReturnReceive/Index';
import PermissionDenied from './PermissionDenied';

export default function PartnerStockReturnReceive() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['partner-stock-return-receive']) return <PermissionDenied />;

    return (
        <StockReturnApprovalProvider>
            <Index />
        </StockReturnApprovalProvider>
    );
}
